import { ITool, IToolEditor, IToolModel, CompositeOp, IToolData, Layer, ToolId } from '../interfaces';
import { faWrench } from '../icons';
import { addRect, intersectRect, makeIntegerRect, setRect, createRect, cloneRect } from '../rect';
import { createPoint } from '../point';
import { createViewport, screenToDocumentXY } from '../viewport';
import { BLACK } from '../constants';
import { setupSurface } from '../toolSurface';
import { releaseToolRenderingContext } from '../user';
import { redrawLayer } from '../../services/editorUtils';
import { finishTransform } from '../toolUtils';

const temp = createPoint(0, 0);

export class RefTool implements ITool {
  id = ToolId.Ref;
  name = 'Reference tool';
  icon = faWrench;
  view = createViewport();
  private tempRect = createRect(0, 0, 0, 0);
  private layer: Layer | undefined = undefined;
  constructor(public editor: IToolEditor, public model: IToolModel) {
  }
  private paint(x: number, y: number) {
    if (this.model.user.surface.context) {
      setRect(this.tempRect, x - 6, y - 6, 12, 12);
      this.model.user.surface.context.fillCircle(BLACK, x, y, 5);
      this.model.user.surface.context.flush();
      redrawLayer(this.editor, this.layer, this.tempRect);

      const rect = this.model.user.surface.rect;
      addRect(rect, this.tempRect);
      intersectRect(rect, this.editor.drawing.rect);
      makeIntegerRect(rect);
    }
  }
  setup() {
    this.layer = this.model.user.activeLayer;
  }
  start(x: number, y: number, pressure: number) {
    if (!this.layer) throw new Error('[RefTool.start] Missing layer');

    finishTransform(this.editor, this.model.user, 'RefTool');
    this.model.startToolView<IToolData>(this.layer.id, this.view, { id: this.id }, x, y, pressure);
    this.editor.renderer.getToolRenderingContext(this.model.user);
    setupSurface(this.model.user.surface, this.id, CompositeOp.Draw, this.layer);

    screenToDocumentXY(temp, x, y, this.view);
    this.paint(temp.x, temp.y);
  }
  move(x: number, y: number, pressure: number) {
    this.model.nextTool(x, y, pressure);

    screenToDocumentXY(temp, x, y, this.view);
    this.paint(temp.x, temp.y);
  }
  end(x: number, y: number, pressure: number) {
    if (!this.layer) throw new Error('[RefTool.end] Missing layer');

    screenToDocumentXY(temp, x, y, this.view);
    this.paint(temp.x, temp.y);
    releaseToolRenderingContext(this.model.user);
    this.model.user.history.pushDirtyRect('ref', this.layer.id, this.model.user.surface.rect);
    const beforeRect = cloneRect(this.layer.rect);
    this.editor.renderer.commitTool(this.model.user, false);
    this.model.endTool(this.id, x, y, pressure, beforeRect, this.layer.rect, 0, 0, 0, 0);
  }
}
